import { API, graphqlOperation } from "aws-amplify";
import { appsyncError } from "./errors";

export const paginateData = async ({ operation, operationName, input }) => {
  let token = null;
  const data = [];

  try {
    do {
      const response = await API.graphql(
        graphqlOperation(operation, { ...input, after: token })
      );
      
      if (response?.data?.[operationName]?.items) {
        data.push(...response.data[operationName].items);
        token = response.data[operationName].nextToken;
      } else {
        break;
      }
    } while (token);
  } catch (e) {
    throw appsyncError(e);
  }

  return data;
};
